export default function SocialsIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.18 12.83h5.52c1.55 0 2.8-1.18 2.8-2.65V3.15A2.72 2.72 0 0 0 13.7.5H3.3A2.72 2.72 0 0 0 .5 3.15v7.03a2.72 2.72 0 0 0 2.8 2.64h1.03v2.68l3.85-2.68h0Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g transform="translate(3.5 8)" fill="currentColor">
          <circle cx="1" cy=".94" r="1" />
          <circle cx="5" cy=".94" r="1" />
          <circle cx="9" cy=".94" r="1" />
        </g>
      </g>
    </svg>
  );
}
